import { EmptyState, EmptyStateProps } from '@components/empty-state';
import { IconFilter } from '@components/icons/filter';
import { useScopedTranslate } from '@locale/translate';

export type EmptyFiltersStateProps = Omit<EmptyStateProps, 'icon' | 'header' | 'content'>;

export const EmptyFiltersState: React.FC<EmptyFiltersStateProps> = (props) => {
  const { t } = useScopedTranslate(locale);
  return (
    <EmptyState
      {...props}
      icon={<IconFilter size={80} />}
      header={t('header')}
      content={t('content')}
    />
  );
};

const locale = {
  en: {
    header: 'No matches',
    content: 'There are no results based on your filters',
  },
  is: {
    header: 'Engar niðurstöður',
    content: 'Engar niðurstöður passa við virka síu',
  },
};
